import { Component, OnInit, Renderer2 } from '@angular/core';
import { AuthorizationService } from '../services/authorization.service';
import { AuthorizationRequest } from '../model/authorization-request.model';
import { GrantType } from '../model/grant-type.enum';
import { TranslateService } from '@ngx-translate/core';
import { _ } from '@biesbjerg/ngx-translate-extract/dist/utils/utils';
import { NotificationService } from '../services/notification.service';

@Component({
  selector: 'app-authorization',
  templateUrl: './authorization.component.html',
  styleUrls: ['./authorization.component.scss']
})
export class AuthorizationComponent implements OnInit {

  constructor(private renderer: Renderer2,
              private authorizationService: AuthorizationService,
              private translateService: TranslateService,
              private notificationService: NotificationService) {
  }

  isVisible = true;
  labelLocation = 'top';
  labelMode = 'floating';
  submitButtonOptions: any = {
    useSubmitBehavior: true,
    type: 'success',
    text: this.translateService.instant(_('Login'))
  };
  authorization: AuthorizationRequest = {
    username: '',
    password: '',
    grant_type: GrantType.PASSWORD
  };

  ngOnInit(): void {
    this.toggleBodyClass(true);
  }

  onFormSubmit(e: any): void {
    this.toggleBodyClass(false);
    this.authorizationService.login(this.authorization).then(result => {
      if (result.isAuthorized) {
        this.isVisible = false;
      } else if (result.error) {
        if (result.error?.error?.error_description) {
          this.notificationService.showErrorMessage(result.error.error.error_description);
        }
      } else {
        this.notificationService.showErrorMessage('Error logging in, check your credentials and try again!');
      }
    });
    e.preventDefault();
  }

  private toggleBodyClass(add: boolean): void {
    if (add) {
      this.renderer.addClass(document.body, 'initializing');
    } else {
      this.renderer.removeClass(document.body, 'initializing');
    }
  }
}
